import { defaultPhoneModel } from '@const/defaultPhoneModel';

/**
 * Maps a phone object for a create/update mutation input. Returns null when there's no
 * number to send. Some contacts have a phone number saved without country/code (legacy
 * data, imports), and those are non-nullable on the server — backfill them here rather
 * than sending null and failing the mutation.
 */
export const mapPhone = (phone) => {
  if (!phone?.phone) {
    return null;
  }

  return {
    ...phone,
    country: phone.country || defaultPhoneModel.country,
    code: phone.code || defaultPhoneModel.code,
  };
};
